
import { useState,useEffect } from 'react'
import './styles/RolesAdmin.css'
import Action from '../Action'
import { useFetch } from '../../hooks/useFetch'
import Selector from '../Selector'
import LoadSimple from '../LoadSimple'
import {roles}  from '../generales/GroupsId';
import Search from '../generales/Search'
import { lang } from '../generales/traduction'
import { capitalizeFirstLetter } from '../../utils/utils'
import Modal from 'react-modal';
import ModalCreateRol from './ModalCreateRol'
import Paginador from '../generales/Paginador'
import TableRoles from './TableRoles'
import RolesList from './RolesList'
const CreateCisModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    background: "#ffffff !important",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "70%",
    height: "80%",
    padding: "20px",
  },
};
const RolesAdmin=({server,languaje,mode})=>{
  const [error,setError]=useState(null);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [screenHeight, setScreenHeight] = useState(window.innerHeight);
  const [editActive, setEditActive] = useState(false);
  const [nivelForm,setNivelForm]=useState(1)
  const [userData,setUserData]=useState({name:"",description:"",permissions:""})
  const [disabled,setDisabled]=useState(true)
  const [permisos,setPermisos]=useState([])
  const [loading,setLoading]=useState(false)
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [rolSelected,setRolSelected]=useState(0)
  const [registerIsValid, setRegisterIsValid] = useState(false);
  const [data,setData]=useState([]);
  const [checkboxes, setCheckboxes] = useState({
      checkbox1: false,
      checkbox2: false,
      checkbox3: false,
      checkbox4: false,
      checkbox5: false,
    });
  const [infoPermission,setInfoPermission]=useState('')
  const [dataPermisos,setDataPermisos]=useState({data:[],loading:true,error:''})
  const [dataRoles,setDataRoles]=useState({data:[],loading:true,error:''})
  const [RolData,setRolData]=useState({data:[],loading:false,error:''})
  const limitList = 200;
  const [pageActual, setPageActual] = useState(1);
  const startLimit = limitList * pageActual - limitList;
  const [dataUsers, setDataUsers] = useState({
    data: [],
    loading: true,
    error: null,
  });
  const [searchResults, setSearchResults] = useState([]);
  const [searchResult, setSearchResult] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  var dataList = searchTerm === "" ? (dataRoles.data.length==0?[]:dataRoles.data.data) : searchResults;
  const [CreateCisModalOpen, setCreateCisModalOpen] = useState(false);
  const pages = parseInt(dataList.length / limitList) + 1;
  const crear = () => {
    // Aquí puedes realizar la búsqueda usando el valor de 'query'
    // Por ejemplo, puedes actualizar el estado 'searchResult' con los resultados
    setCreateCisModalOpen(true);
  };
  // const dataPermisos=useFetch('cassia/users/roles/permissions/get','',localStorage.getItem('access_token'),'GET',server)
  // const dataRoles=useFetch('cassia/users/roles','',localStorage.getItem('access_token'),'GET',server)
  function closCreateCisModal() {
    setPermisos([])
    setEditActive(false);
    setCreateCisModalOpen(false);
  }
  const addPermiso=(e)=>{
    if (permisos.includes(e)) {
      // Eliminar el valor si ya existe
      let objSlctd=dataPermisos.data.data.filter(element=> element.permission_id===e)
      let arraySubstract=[]
      if (objSlctd[0].Nivel==1) {
        arraySubstract= dataPermisos.data.data.filter(item => item.name === objSlctd[0].module_name).map(item => item.permission_id)
      }else if (objSlctd[0].Nivel==2) {
        arraySubstract= dataPermisos.data.data.filter(item => item.description === objSlctd[0].module_name).map(item => item.permission_id)
      }
      const nuevoArreglo = permisos.filter(valor => valor !== e);
      const resultado = nuevoArreglo.filter(item => !arraySubstract.includes(item))
      setPermisos(resultado);
    } else {
        // Agregar el valor si no existe
        const nuevoArreglo = [...permisos, e];
        setPermisos(nuevoArreglo);
      }
    // const nuevoArreglo = [...permisos, e]
  }

  useEffect(()=>{
     
      if(permisos.length!==0  && userData.name!==""){
          setDisabled(false)
      }else{
          setDisabled(true)
      }
      setUserData((prevState)=>{
          return {
              ...prevState,
              ['permissions']:permisos.join(',')
          }
          
      })
  },[permisos])
  useEffect(()=>{
    if(editActive){
  
      const permissionIds = RolData.data.data.permissions.map(item => item.permission_id);
      setPermisos(permissionIds)
     
    }
    
},[RolData.data])
  const handleChange=(e)=>{
    const {name,value}=e.target
    setUserData((prevState)=>{
        return {
            ...prevState,
            [name]:value
        }
        
    })
    if(permisos.length!==0  && value!==""){
        setDisabled(false)
    }else{
        setDisabled(true)
    }
  }

  const getPermisos=()=>{
    
    setDataPermisos({data:dataPermisos.data,loading:true,error:''})
      const fetchDataPost = async () => {
        
     try {
        
          const response = await fetch(server.url+'/api/v1/cassia/users/roles/permissions/get', {
            method: 'GET',  
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${localStorage.getItem('access_token')}`,
            },
          });
        
          if (response.ok) {
            
            const data1 = await response.json();
           
            setDataPermisos({data:data1,loading:false,error:''})
           
          } else {
            throw new Error('Error en la solicitud');
          }
        } catch (error) {
            setDataPermisos({data:dataPermisos.data,loading:false,error:''})
          console.error(error);
        }
      };
  
      fetchDataPost();
      

}
  const getRoles=()=>{
   
    setDataRoles({data:dataRoles.data,loading:true,error:''})
      const fetchDataPost = async () => {
        
     try {
      
          const response = await fetch(server.url+'/api/v1/cassia/users/roles', {
            method: 'GET',  
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${localStorage.getItem('access_token')}`,
            },
          });
         
          if (response.ok) {
            
            const data1 = await response.json();
           
            setDataRoles({data:data1,loading:false,error:''})
           
          } else {
            throw new Error('Error en la solicitud');
          }
        } catch (error) {
            setDataRoles({data:dataRoles.data,loading:false,error:''})
          console.error(error);
        }
      };
  
      fetchDataPost();
      

}
  useEffect(()=>{
    getPermisos()
    getRoles()
  },[])

  const getRolData=(rol_id)=>{
    
    setRolData({data:RolData.data,loading:true,error:''})
    setDataPermisos({data:dataPermisos.data,loading:true,error:''})
      const fetchDataPost = async () => {
        
     try {
       const response = await fetch(server.url+'/api/v1/cassia/users/roles/'+rol_id, {
         method: 'GET',  
         headers: {
           'Content-Type': 'application/json',
           Authorization: `Bearer ${localStorage.getItem('access_token')}`,
         },
       });
       if (response.ok) {
         
         const data1 = await response.json();
       
        setRolData({data:data1,loading:false,error:''})
        setDataPermisos({data:dataPermisos.data,loading:false,error:''})
        setUserData((prevState)=>{
         return {
             ...prevState,
             ['name']:data1.data.name
         }
         
     })
       } else {
         throw new Error('Error en la solicitud');
       }
     } catch (error) {
          setRolData({data:RolData.data,loading:false,error:''})
          setDataPermisos({data:dataPermisos.data,loading:false,error:''})
          console.error(error);
        }
      };
  
      fetchDataPost();
      

}
  const SelectRol=(rol_id)=>{
    setEditActive(true)
    setRolSelected(rol_id)
    getRolData(rol_id)
  }

  const handledeleteRolClick=(rol_id)=>{
    setDataRoles({data:dataPermisos.data,loading:true,error:''})

    const fetchDataPost = async () => {
      
   try {
     const response = await fetch(server.url+'/api/v1/cassia/users/roles/'+rol_id, {
       method: 'Delete',  
       headers: {
         'Content-Type': 'application/json',
         Authorization: `Bearer ${localStorage.getItem('access_token')}`,
       },
     });
     if (response.ok) {
       
       const data1 = await response.json();
      
       getRoles()
      
     } else {
       throw new Error('Error en la solicitud');
     }
   } catch (error) {
          setDataRoles({data:dataPermisos.data,loading:false,error:''})
        console.error(error);
      }
    };

    fetchDataPost();
  }
  const handleChangEdit=(user)=>{
    setLoading(false)
   
    // console.log(user.roles)
    // const rolIds = user.roles.map(obj => obj.rol_id).join(',')
    // console.log(rolIds)
    setEditActive(true)
    setCreateCisModalOpen(true)
    getRoles()
    setUserData({name:user.name,description:user.description,permissions:permisos})
    // setUserId(user.user_id)
    // setRol(rolIds)
}

  const Regresar=()=>{
    setRolSelected(0)
    setEditActive(false)
    setRolData({data:[],loading:true,error:''})
    getPermisos()
    setPermisos([])
    setUserData({name:"",description:"",permissions:""})
    // setLoading(false)
  }
  const showInfo=(e,info)=>{
    // console.log(e)
    // setPosition({ x: e.pageX, y: e.pageY });
    // setInfoPermission(info)
  }
  const {name,description,permissions}=userData
  return (
    <>
    <div className='head-cis'>
    <div className='title-cis'>
                <Search
                    searchResults={searchResults}
                    setSearchResults={setSearchResults}
                    searchTerm={searchTerm}
                    setSearchTerm={setSearchTerm}
                    // onSearch={handleSearch}
                    dataObject={dataRoles.data.data}
                    setDataObject={setDataUsers}
                    searchResult={searchResult}
                    setSearchResult={setSearchResult}
                    languaje={languaje}
                  />
          <div className={"cont-result-registers"+mode}>
         
                  <p style={{  textAlign: "center" }}>
                    &nbsp;
                    {capitalizeFirstLetter(lang[languaje]['resultadosEncontrados'])+" (" +
                      dataList.length +
                      ") " 
                      }
                  </p> 
          </div>
          <div className="cont-buttons-panel">
                  
                    <Action
                    disabled={false}
                    origen="Azul"
                    titulo={"+ "+capitalizeFirstLetter(lang[languaje]['nuevoRegistro'])}
                    action={crear}
                  />
                  
                 
                </div>
                </div>
                
            </div>
            <div className='cont-cis'>
            <>
      <div className="main-panel-cis">
      <div className="compact-content-portafolio">
      <div className={"content-portafolio-head"+mode}>
              
              
              </div>
        <div className="content-portafolio">
          

          <div className="cont-portafolio-table">
            <div className="content-card-portafolio" id="content">
              {/*  aqui inicia */}
<>
<RolesList
                        mode={mode}
                        // handleShowPopup={handleShowPopup}
                         handleChangEdit={handleChangEdit} 
                        server={server}
                        title='work station'
                        languaje={languaje}
                        SelectRol={SelectRol}
                        getRoles={getRoles}
                        // hostSelected={hostSelected}
                        // setHostSelected={setHostSelected}
                        // openAddHostModal={openAddHostModal}
                        // showHistoric={showHistoric}
                        pageActual={pageActual}
                        startLimit={startLimit}
                         limitList={limitList} 
                        dataList={dataList}
                        dataDevices={dataRoles}
                        setDataDevices={setDataRoles}
                        // listSelected={listSelected}
                        // setPages={setPages}
                        // setLimitList={setLimitList}
                        setPageActual={setPageActual}
                        // setTotalRecord={setTotalRecord}
                        searchTerm={searchTerm}
                        setSearchTerm={setSearchTerm}
                        // dataServers={dataServers}
                        // dataCriticalities={dataCriticalities}  dataAgencies={dataAgencies}
                      />
{/* <TableRoles getRoles={getRoles} dataRoles={dataRoles} SelectRol={SelectRol}  dataPermisos={dataPermisos} handledeleteRolClick={handledeleteRolClick} setDataUsers={setDataUsers} dataUsers={dataUsers} pageActual={pageActual}  limitList={limitList} startLimit={startLimit} dataList={dataList} languaje={languaje} mode={mode} registerIsValid={registerIsValid}  server={server} handleChangEdit={handleChangEdit} setData={setData} setLoading={setLoading} setError={setError}/> */}
                           
                     
</>

     {/*  aqui termina */}         
            </div>
          </div>
        </div>
        <div className={"content-portafolio-footer"+mode}>
          <div className="cont-display-paginador">
                    <Paginador  pages={pages}
                                pageActual={pageActual}
                                setPageActual={setPageActual}
                                mode={mode}></Paginador>
          </div>
          <div className="cont-display-paginador">
            <div className={"cont-half-display-paginador"+mode}>
                      
                  
            </div>
            <div className={"cont-half-display-paginador"+mode}>
            <p style={{  textAlign: "center" }}>
                            &nbsp;
                            {"(" +
                        (startLimit + 1) +
                        " - " +
                        (dataList.length >  parseInt(pageActual ) * parseInt(limitList)
                          ?  parseInt(pageActual ) * parseInt(limitList)
                          : dataList.length) +
                        ")  "+lang[languaje]['de']+" " +
                        dataList.length +
                        " "+lang[languaje]['resultados']}
                      </p>
                  
            </div>
          </div>  
                    
        </div>
        </div>

      </div>
      <Modal
        isOpen={CreateCisModalOpen}
        // isOpen={false}
        // onAfterOpen={afterOpenExeption}
        onRequestClose={closCreateCisModal}
        style={CreateCisModalStyles}
        contentLabel="Example Modal2"
        shouldCloseOnOverlayClick={false}
      >
      <ModalCreateRol
    //   devices={devices}
      server={server}
      editActive={editActive}
      setEditActive={setEditActive}
    //   dataCis={dataCis}
      // setData={setData}
      loading={loading}
      setLoading={setLoading}
      setError={setError}
      // setRegisterIsValid={setRegisterIsValid}
      closCreateCisModal={closCreateCisModal}
      dataMantto={userData}
      languaje={languaje}
                      mode={mode}
                      dataRoles={dataRoles}
                      userData={userData}
                    //   addRoles={addRoles}
                      // userId={userId}
                      getRoles={getRoles}
                      dataPermisos={dataPermisos}
                      showInfo={showInfo}
                      setInfoPermission={setInfoPermission}
                      RolData={RolData}
                      addPermiso={addPermiso}
                      rolSelected={rolSelected}
                      setDataPermisos={setDataPermisos}
                      setPermisos={setPermisos}
                      getPermisos={getPermisos}
                      permisos={permisos}
                      setUserData={setUserData}
    ></ModalCreateRol>
    </Modal>
     
    </>
                
            </div>
    </>
  )
}

export default RolesAdmin